import { AutocompleteProvider } from './autocomplete.provider';

import React from 'react';
import { AutocompleteViewModel } from './autocomplete.view-model';
import { Autocomplete, AutocompleteOption } from './autocomplete.view';

const AutocompleteRoot = <TValue extends unknown = unknown>({
   viewModel,
   children,
   placeholder,
   disabled,
   onSearch,
}: {
   viewModel: AutocompleteViewModel<TValue>;
   children: React.ReactNode[];
   placeholder?: string;
   disabled?: boolean;
   onSearch?: (val: string) => void;
}) => {
   const [vm] = React.useState(() => viewModel);
   return (
      <AutocompleteProvider viewModel={vm}>
         <Autocomplete disabled={disabled} onSearch={onSearch} placeholder={placeholder}>
            {children}
         </Autocomplete>
      </AutocompleteProvider>
   );
};

export { AutocompleteRoot as Root, AutocompleteOption as Option };
